import React from 'react';
import { useIntl } from 'react-intl';

import { renderQAWithBreaks } from '@utils/translations';

const PartnersTab = () => {
  const intl = useIntl();

  return (
    <div>
      <h3>{intl.formatMessage({ id: 'Types of Publisher Permitted On The Program'})}</h3>
      {renderQAWithBreaks(intl.formatMessage({ id: 'Types of Publisher Permitted On The Program QA 1' }))}
      <p>
        <strong>
          {intl.formatMessage({ id: 'Use of Voucher Codes N.B.: All Affiliates that use voucher codes must adhere to the IAB voucher Code of Conduct. For more information, please read' })}{' '}
          <a
            href='http://www.iabuk.net/resources/standards-and-guidelines/online-voucher-codes'
            target='_blank'
            rel='noopener noreferrer'
          >
            http://www.iabuk.net/resources/standards-and-guidelines/online-voucher-codes
          </a>
        </strong>
      </p>
      {renderQAWithBreaks(intl.formatMessage({ id: 'Types of Publisher Permitted On The Program QA 2' }))}
      <h3>{intl.formatMessage({ id: 'Use of Sub Affiliate Networks' })}</h3>
      {renderQAWithBreaks(intl.formatMessage({ id: 'Use of Sub Affiliate Networks QA'}))}
      <h3>{intl.formatMessage({ id: 'PPC (Search Engine Pay Per Click) Affiliates' })}</h3>
      {renderQAWithBreaks(intl.formatMessage({ id: 'PPC (Search Engine Pay Per Click) Affiliates QA 1'}))}
      <p>
        {intl.formatMessage({ id: 'If Uniplaces has restrictions, please list the exact terms that affiliates are not permitted to bid on.' })}
      </p>
      <p>{intl.formatMessage({ id: 'No PPC bidding or SEO practises allowed.' })}</p>
      {renderQAWithBreaks(intl.formatMessage({ id: 'PPC (Search Engine Pay Per Click) Affiliates QA 2'}))}
      <h3>{intl.formatMessage({ id: 'URL and ad copy restrictions' })}</h3>
      {renderQAWithBreaks(intl.formatMessage({ id: 'URL and ad copy restrictions QA'}))}
      <h3>{intl.formatMessage({ id: 'Direct linking restrictions' })}</h3>
      {renderQAWithBreaks(intl.formatMessage({ id: 'Direct linking restrictions QA'}))}
      <h3>{intl.formatMessage({ id: 'Branding Guidelines' })}</h3>
      {renderQAWithBreaks(intl.formatMessage({ id: 'Branding Guidelines QA'}))}
      <h3>{intl.formatMessage({ id: 'Creative Restrictions' })}</h3>
      {renderQAWithBreaks(intl.formatMessage({ id: 'Creative Restrictions QA'}))}
      <h3>{intl.formatMessage({ id: 'Copy Compliance' })}</h3>
      {renderQAWithBreaks(intl.formatMessage({ id: 'Copy Compliance QA'}))}
      <h3>{intl.formatMessage({ id: 'Deeplinking' })}</h3>
      {renderQAWithBreaks(intl.formatMessage({ id: 'Deeplinking QA'}))}
      <h3>{intl.formatMessage({ id: 'Mobile Tracking' })}</h3>
      {renderQAWithBreaks(intl.formatMessage({ id: 'Mobile Tracking QA'}))}
      <h3>{intl.formatMessage({ id: 'Mobile applications' })}</h3>
      {renderQAWithBreaks(intl.formatMessage({ id: 'Mobile applications QA'}))}
      <h2>{intl.formatMessage({ id: 'General' })}</h2>
      <h3>{intl.formatMessage({ id: 'Regional restrictions' })}</h3>
      {renderQAWithBreaks(intl.formatMessage({ id: 'Regional restrictions QA'}))}
      <h3>{intl.formatMessage({ id: 'Product information' })}</h3>
      {renderQAWithBreaks(intl.formatMessage({ id: 'Product information QA'}))}
    </div>
  );
}

export default PartnersTab;
